// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1297":"f813e561","3256":"4e93ebbd","4126":"ae3351bc","5105":"a57a0731","5114":"84b6a84e"}[chunkId] + ".chunk.css";
};